module.exports = __webpack_public_path__ + "static/media/right.2aecf3c5.svg";